import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';

import LoadingSpinner from '../loadingSpinner/';
import Sport from './liveMenuSport';
import Favourites from './liveMenuFavourites';
import Popular from './liveMenuPopular';
import Schedule from './schedule';
import WithVideo from './withVideo';


@inject('lineStore')
@observer
class LiveMenu extends Component {
  render() {
    if (!this.props.lineStore.menu.mode) {
      return null;
    }

    const { isLoadMenu, sportOrder, mode } = this.props.lineStore.menu;

    if (isLoadMenu) {
      return (
        <div className="favourites-loader-wrap">
          <LoadingSpinner />
        </div>
      );
    }

    return (
      <div className="line-left-column-left-menu-cont">
        <div className="line-left-menu-cont">
          <Favourites />
          <div
            id="wrapper-scroll-menu"
            className="not-favourites-wrapper"
          >
            {mode === 'line' && <Popular />}
            {mode === 'live' && <WithVideo mode={mode} />}
            {sportOrder.map(id => (
              <Sport
                key={id}
                id={id}
                type={1}
              />
            ))}
            {mode === 'live' && <Schedule />}
          </div>
        </div>
      </div>
    );
  }
}

export default LiveMenu;


// WEBPACK FOOTER //
// ./src/components/liveMenu/liveMenu.jsx